<button
  data-ui-sound
  class="{{ type() }} {{ size() }} {{ radius() }}"
  mnClickActivate
  mnClickArea
  [disabled]="disabled()"
  [mnAnalyticsClick]="aEvent()"
  (click)="onClick($event)">
  <ng-content></ng-content>
</button>
